import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.UPDATES_CHECK]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Updates checked'),
      message: i18n.t('Updates successfully checked'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Checking updates...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error checking updates'),
      message: error
    })
  },
  [TaskName.UPDATES_DOWNLOAD]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Updates downloaded'),
      message: i18n.t('Updates successfully downloaded'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Downloading updates...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Downloading updates failed'),
      message: error
    })
  },
  [TaskName.UPDATES_CANCEL]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Update canceled'),
      message: i18n.t('Update successfully canceled'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error cancelling update'),
      message: error
    })
  },
  [TaskName.UPDATES_PAUSE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Update paused'),
      message: i18n.t('Update successfully paused'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error pausing update'),
      message: error
    })
  },
  [TaskName.UPDATES_START]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Update completed'),
      message: i18n.t('Update successfully completed'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Installing updates failed'),
      message: error
    })
  },
  [TaskName.UPDATES_RESUME]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Update resumed'),
      message: i18n.t('Update successfully resumed'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error resuming update'),
      message: error
    })
  }
};

export default taskMap;
